import { useEffect } from "react";
import { Card, Form, Input, Button, message } from "antd";
// 先注释接口，保留静态页面，后续对接后端再打开
// import { getBaseSetting, saveBaseSetting } from "../api";

export default function SettingBase() {
  const [form] = Form.useForm();

  // 临时注释接口调用，避免报错（静态页面）
  useEffect(() => {
    // 对接后端时打开：getBaseSetting().then(form.setFieldsValue);
    // 可先设置默认值
    form.setFieldsValue({
      siteName: "云交租",
      record: "粤ICP备12345678号"
    });
  }, [form]);

  const onFinish = (values) => {
    // 临时提示，对接后端时替换为接口调用
    // saveBaseSetting(values).then(() => message.success("已保存"));
    message.success("保存成功（静态页面，仅做展示）");
    console.log("基础设置保存值：", values);
  };

  return (
    <div>
      <h2>⚙️ 基础设置</h2>
      <Card style={{ maxWidth: 600 }}>
        <Form 
          form={form} 
          layout="vertical" 
          onFinish={onFinish}
          initialValues={{
            siteName: "租房管理系统",
            record: "粤ICP备12345678号"
          }}
        >
          <Form.Item
            label="站点名称"
            name="siteName"
            rules={[{ required: true, message: "请输入站点名称" }]}
          >
            <Input placeholder="请输入站点名称" />
          </Form.Item>
          <Form.Item 
            label="备案号" 
            name="record"
            rules={[{ required: false }]}
          >
            <Input placeholder="请输入网站备案号" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}